import inputStyles from '../Styles/inputStyles';
import styled from '../Styles/styled-components';

export const Textarea = styled.textarea`
  ${inputStyles}
  padding: 10px 18px;
  min-height: 200px;
  resize: none;
`;
export default Textarea;
